/**
 * @generated SignedSource<<20d2394031d7d7f56a8f2f42884d2a5b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommunicationTemplateUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCommunicationTemplateTPayload",
        "kind": "LinkedField",
        "name": "updateCommunicationTemplateTByCtId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CommunicationTemplateT",
            "kind": "LinkedField",
            "name": "communicationTemplateT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommunicationTemplateUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCommunicationTemplateTPayload",
        "kind": "LinkedField",
        "name": "updateCommunicationTemplateTByCtId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CommunicationTemplateT",
            "kind": "LinkedField",
            "name": "communicationTemplateT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3630fea0f08871b619167d77b6847b06",
    "id": null,
    "metadata": {},
    "name": "CommunicationTemplateUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation CommunicationTemplateUpdateMutation(\n  $input: UpdateCommunicationTemplateTByCtIdInput!\n) {\n  updateCommunicationTemplateTByCtId(input: $input) {\n    communicationTemplateT {\n      ctId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "4c556309b2e1db220f667c93b3368d57";

module.exports = node;
